export enum MergerStatusType
  {
    Successor = 1,
    Child = 2,
    NotMerged = 3

  }